//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.js";
import "../no/TaggedObjectCollection.js";
import "../Routing/Routing.RouteManager.js";
let d=[[],[[["start_control_point","segments","stocks","overstock_part","stock_wrap_type","wrap_value"],"CreateOverstockApplication",{R_:{overstock_application:"Routing.OverstockApplication"}},6,0],[["start_control_point","segments","stocks","start_offset","end_offset","piece_length","gap","number_of_pieces","start_point","overstock_part","stock_wrap_type","wrap_value"],"CreateOverstockApplication1",{R_:{overstock_application:"Routing.OverstockApplication"}},12,0],[["start_control_point","segments","stocks","start_point","end_point","overstock_part","stock_type","wrap_value"],"CreateOverstockApplication2",{R_:{overstock_application:"Routing.OverstockApplication"}},8,0],[["start_control_point","segments","stocks","defining_point","defining_direction","piece_length","overstock_part","stock_wrap_type","wrap_value"],"CreateOverstockApplication3",{R_:{overstock_application:"Routing.OverstockApplication"}},9,0],[["start_control_point","segments","stocks","overstock_part","req_opt_charx_list","wrap_value","overstocks"],"ConvertOverstockApplication",{R_:{overstock_application:"Routing.OverstockApplication"}},7,0],[["start_control_point","segments","stocks","start_offset","end_offset","piece_length","gap","number_of_pieces","start_point","overstock_part","req_opt_charx_list","wrap_value","overstocks"],"ConvertOverstockApplication1",{R_:{overstock_application:"Routing.OverstockApplication"}},13,0],[["start_control_point","segments","stocks","start_point","end_point","overstock_part","req_opt_charx_list","wrap_value","overstocks"],"ConvertOverstockApplication2",{R_:{overstock_application:"Routing.OverstockApplication"}},9,0],[["start_control_point","segments","stocks","defining_point","defining_direction","piece_length","overstock_part","req_opt_charx_list","wrap_value","overstocks"],"ConvertOverstockApplication3",{R_:{overstock_application:"Routing.OverstockApplication"}},10,0],[["charxMap","overstock"],"ReplaceOverstockApplication",{},2,0]],[]];
SPLM.Routing.OverstockApplicationCollection = class extends SPLM.TaggedObjectCollection{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Routing.OverstockApplicationCollection";
        SPLM.c$d(this.Class,d);d=[];
    }
    ToArray(context)
    {
        let r={};
        if(context === undefined){
            r.ToArray={"context":this._d.ObjectId};
        }
        else{
            r.ToArray={"context":context};
        }
        r.Class=this._d.Class;
        if(SPLM.api === undefined){
            this._d.ToArray=r.ToArray;
        }
        else{
            SPLM.api.push(r);
        }
        return r;
    }
};

SPLM.Routing.Operation = Object.freeze({
    "Create" : "Create", "Edit" : "Edit"});

SPLM.Routing.Method = Object.freeze({
    "EntireSegments" : "EntireSegments", "Interval" : "Interval", "PointToPoint" : "PointToPoint", "PointAndLength" : "PointAndLength"});

SPLM.Routing.StockType = Object.freeze({
    "Unknown" : "Unknown", "FixedCrossSection" : "FixedCrossSection", "Wrapped" : "Wrapped", "Sleeved" : "Sleeved", "Flagged" : "Flagged"});

SPLM.Routing.WrapApplicationType = Object.freeze({
    "Unknown" : "Unknown", "Spot" : "Spot", "Overlapped" : "Overlapped", "Gapped" : "Gapped"});

SPLM.Routing.PointDefinition = Object.freeze({
    "Start" : "Start", "Middle" : "Middle", "End" : "End"});

export default SPLM;